
import { fromTime, fromFormatDate } from '../functions/Utilities';

const TelephoneLinesDown = (props) => {  

return (  
        <div className="notice"> 
            <div className="notice_body" id="share">
            <div className="notice_type planned_type">DATE: {fromTime(props.notice.notice_time).toUpperCase()}</div>
                <div className="telephone">TELEPHONE LINES DOWN</div>  
                <div className="telephone_message"> 
                <p>Please be advised that we are currently experiencing power outages thus affecting our telephone service. Technicians are currently attending to the issue and customers are urged to E-mail <a href="mailto:enquiries@silulumanzi.com">enquiries@silulumanzi.com</a> or send an inbox to our Facebook page <a href="https://www.facebook.com/silulumanzi">www.facebook.com/silulumanzi</a> or WhatsApp <strong>083 269 1456</strong>.</p> 
                <p>Thank you for your patience.</p>

                </div> 
            </div> 
        </div>  
    );
}

export default TelephoneLinesDown;

